import { TsButtonModule } from 'tsui';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CalculatorComponent } from 'app/layout/common/calculator/calculator.component';
import { SharedModule } from 'app/shared/shared.module';
import { CalculatorModalComponent } from 'app/layout/common/calculator/calculator-modal/calculator-modal.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

@NgModule({
  declarations: [CalculatorComponent, CalculatorModalComponent],
  imports: [
    TsButtonModule,
    MatIconModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    CurrencyMaskModule,
    MatDialogModule,
  ],
  exports: [CalculatorComponent],
})
export class CalculatorModule {}
